import EFPicture from 'elem/compCommon/EFPicture';
import BuiltInBattery from '@elem/SVGIcon/VanlifeRoadtrips/BuiltInBattery';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
// import IP68 from '@elem/SVGIcon/VanlifeRoadtrips/IP68';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const LFPICON = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
        <path
            d="M13.9987 10.9001H29.9987L29.9996 8.49976H33.9996L33.9987 10.9001H40.9996C41.5666 10.9001 42.0335 11.3286 42.0934 11.8796L42.1002 11.9998V36.9998C42.1002 37.5668 41.6709 38.0338 41.1198 38.0935L40.9996 38.0994H2.99963C2.4329 38.0992 1.9667 37.6707 1.90686 37.1199L1.90002 36.9998V11.9998C1.90002 11.4327 2.32936 10.9657 2.88049 10.906L2.99963 10.9001H9.99866L9.99963 8.49976H13.9996L13.9987 10.9001ZM4.10022 35.9001H39.9V13.1003H4.10022V35.9001ZM11.4557 28.4675H16.4156V30.4998H9.27991V18.9802H11.4557V28.4675ZM24.816 21.156H19.9518V23.6521H23.8561V25.8279H19.9518V30.4998H17.776V18.9802H24.816V21.156ZM31.4371 18.9861L31.5719 18.9919C31.7611 18.9999 31.9305 19.0171 32.0797 19.0437C32.7676 19.1504 33.3321 19.3768 33.7721 19.7234C34.2121 20.0701 34.5358 20.5066 34.7438 21.032C34.9517 21.5573 35.0563 22.1426 35.0563 22.7878C35.0563 23.4331 34.9505 24.0184 34.7399 24.5437C34.5293 25.0689 34.2041 25.5047 33.7643 25.8513C33.3243 26.198 32.7624 26.4253 32.0797 26.532C31.9305 26.5533 31.7598 26.5692 31.568 26.5798L31.2076 26.5945L28.4323 26.5955V30.4998H26.2565V18.9802H31.2115L31.4371 18.9861ZM28.4323 24.5642H31.024L31.1393 24.5623L31.3922 24.5476C31.5255 24.5369 31.6484 24.5161 31.7604 24.4841C32.0536 24.4041 32.2801 24.2691 32.4401 24.0798C32.6 23.8906 32.7108 23.6799 32.7721 23.448C32.8334 23.216 32.8639 22.9958 32.8639 22.7878C32.8639 22.5798 32.8334 22.3597 32.7721 22.1277C32.7108 21.8957 32.6 21.6852 32.4401 21.4958C32.2801 21.3066 32.0536 21.1716 31.7604 21.0916C31.6484 21.0596 31.5255 21.0387 31.3922 21.0281L31.1393 21.0134L28.4323 21.0115V24.5642Z"
            fill="white"
        />
    </svg>
);

export default function D_NA() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <PortableDesign />,
            text: t('secD_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secD_tag2'),
        },
        {
            icon: <LFPICON />,
            text: t('secD_tag3'),
        },
    ];
    return (
        <div id="outdoor-recreation-D" className={`outdoor-recreation-D ${css['outdoor-recreation-D']}`}>
            <div className="img-box">
                <EFPicture
                    src={'https://websiteoss.ecoflow.com/upload/image/1747901545170/na.jpg'}
                    srcDesktop={'https://websiteoss.ecoflow.com/upload/image/1747901545170/na.jpg'}
                    srcPad={'https://websiteoss.ecoflow.com/upload/image/1747901545170/na.jpg'}
                    srcMobile={'https://websiteoss.ecoflow.com/upload/image/1747901548621/na_m.jpg'}
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secD_title')}</p>
                    <p className="desc">{t('secD_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
